/**
 * บทประพันธ์/บทอ่านประกอบโจทย์ — ข้อความหลายบรรทัด + **ตารางอย่างง่าย**
 *
 * ข้อสอบ ป.4 มีเรื่องอ่านตารางสองทางและตารางเวลา (17 ก.ย. 2569) จึงรองรับ
 * ตารางแบบ markdown ใน passage แล้วเรนเดอร์เป็น <table> — ไม่ทำระบบใหญ่
 *
 *   | วัน | เช้า | บ่าย |
 *   |---|---|---|
 *   | จันทร์ | เลข | ไทย |
 *
 * กติกา: บรรทัดที่ขึ้นต้นด้วย `|` ติดกันคือหนึ่งตาราง · บรรทัดคั่น `|---|` ข้าม ·
 * แถวแรกเป็นหัวตาราง · บรรทัดอื่นแสดงเป็นข้อความรักษาการขึ้นบรรทัด (pre-line)
 * ★ ข้อความยังตรงต้นฉบับตัวต่อตัว — เราแค่เปลี่ยนวิธีวาง ไม่ได้แก้ตัวอักษร
 */
interface Block {
  kind: 'text' | 'table'
  lines: string[]
}

function split(passage: string): Block[] {
  const blocks: Block[] = []
  for (const line of passage.split('\n')) {
    const isRow = line.trimStart().startsWith('|')
    const last = blocks[blocks.length - 1]
    if (last && (last.kind === 'table') === isRow) last.lines.push(line)
    else blocks.push({ kind: isRow ? 'table' : 'text', lines: [line] })
  }
  return blocks
}

function cells(row: string): string[] {
  return row.trim().replace(/^\|/, '').replace(/\|$/, '').split('|').map((c) => c.trim())
}

const SEPARATOR = /^\|?\s*:?-{2,}:?\s*(\|\s*:?-{2,}:?\s*)*\|?$/

export function Passage({ text }: { text: string }): JSX.Element {
  const blocks = split(text)
  return (
    <blockquote className="passage" data-testid="passage">
      {blocks.map((b, i) => {
        if (b.kind === 'text') {
          const body = b.lines.join('\n')
          // บล็อกข้อความว่าง (ช่องไฟระหว่างตารางกับข้อความ) ไม่ต้องเรนเดอร์อะไร
          return body.trim() ? <p key={i}>{body}</p> : null
        }
        const rows = b.lines.filter((l) => !SEPARATOR.test(l.trim()))
        const [head, ...rest] = rows
        return (
          <table key={i}>
            {head ? (
              <thead>
                <tr>
                  {cells(head).map((c, j) => (
                    <th key={j}>{c}</th>
                  ))}
                </tr>
              </thead>
            ) : null}
            <tbody>
              {rest.map((r, ri) => (
                <tr key={ri}>
                  {cells(r).map((c, j) => (
                    <td key={j}>{c}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        )
      })}
    </blockquote>
  )
}
